<script setup>
import Layout from "@/layouts/main.vue";
import { onMounted, computed, ref} from 'vue';
import PageHeader from "@/components/page-header";
// import appConfig from "../../../app.config";
import Idle from "@/components/traffic-records/idle.vue";
import TrafficRecordComponents from "@/components/traffic-record-components.vue"
import { authHeader } from './../../helpers/authservice/auth-header';
import { useStore } from 'vuex'
import axios from 'axios';

const store = useStore();
const user = computed(() => store.state.auth.user);
const title = ref("Validate");
const items = ref([
    {
        text: "Home",
    },
    {
        text: "Traffic Records",
    },
    {
        text: "Validate",
        active: true,
    }
]);

const getValidateCount = async () => {
    store.dispatch('globals/loading', null, { root: true });

    try {
      const {data} = await axios.get(`/queue/${user.value.id}/validate-count`, {
        headers: authHeader()
      });

      title.value = `Validate: ${data.unfiltered_validate}`;

      store.dispatch('globals/loaded', null, { root: true });
    } catch (err) {
      console.log(err);
      store.dispatch('globals/loaded', null, { root: true });
    }
}

onMounted(async () => {
    await getValidateCount();
});

</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <Idle />
    <TrafficRecordComponents :phase_id="3" />
  </Layout>
</template>
